export default __webpack_public_path__ + "static/media/total-goods-receipts.431c9ff3.svg";